import React from 'react';
import withAuthentication from '../../../../core/login/withAuthentication';
import PaymentInfoForm from './PaymentInfoForm';
import { SectionNumber } from '../../constants';
import { PAYMENT_PAGES } from './constants';
import { GenericSection } from '../Sections/GenericSection';

type Props = {
  searchPreferences?: any;
  addInsurance?: any;
  clearData?: (...args: any[]) => any;
  fetchInsurersList?: (...args: any[]) => any;
  handleFileChange: (...args: any[]) => any;
  insuranceCard?: any;
  insuranceCoverage?: any;
  insurers?: any[];
  submitInsuranceInformation?: (...args: any[]) => any;
};

const PaperworkPayment = (props: Props) => {
  return (
    <GenericSection
      extraFormProps={props}
      formComponent={PaymentInfoForm}
      pageCollection={PAYMENT_PAGES}
      section={SectionNumber}
      sectionValue={SectionNumber.Payment}
    />
  );
};

export default withAuthentication(PaperworkPayment);
